import { FormController } from '@form-ts/core';
import { AuthUser } from 'src/modules/common/types/AuthUser';
import { FormError } from 'src/modules/form/types/FormError';
import { LoginFormData } from 'src/modules/login/types/LoginFormData';
import { createActions } from 'src/utils/createActions';

export const LOGIN_PERFORM = createActions<FormController<LoginFormData, FormError>, AuthUser>('LOGIN_PERFORM');
